/**
 * Protobuf encoder for client -> server commands on the price stream.
 *
 * The streaming-api accepts a `ClientCommand` message on the same WebSocket
 * used for inbound price updates. We send these as binary frames so they
 * piggy-back on the existing protobuf channel.
 */

import { pricestream } from './pricestream.js';

const { ClientCommand } = pricestream;

/**
 * Encode a Subscribe command. When `replace` is true, the lists fully replace
 * the conn's current subscriptions on the server; otherwise they are unioned.
 *
 * `sportIDs` lets a page subscribe to every update within a sport (e.g.
 * `/exchange/soccer/all`) without enumerating every league or game.
 */
export function encodeSubscribe(
  gameIDs: string[],
  leagueIDs: string[],
  sportIDs: string[],
  replace: boolean,
): Uint8Array {
  const cmd = ClientCommand.create({
    subscribe: {
      gameIds: gameIDs,
      leagueIds: leagueIDs,
      sportIds: sportIDs,
      replace,
    },
  });
  return ClientCommand.encode(cmd).finish();
}

/**
 * Encode a SubscribeAll command (explicit firehose opt-in).
 */
export function encodeSubscribeAll(): Uint8Array {
  const cmd = ClientCommand.create({
    subscribeAll: {},
  });
  return ClientCommand.encode(cmd).finish();
}
